namespace GeniuzPOS.ReportMasterData {
    export interface Report_1315Form {
    }

    export class Report_1315Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1315';
    }
}
